import * as styles from './ProgressPips.css';

interface ProgressPipsProps {
  currentStep: number;
  totalSteps: number;
  className?: string;
}

/**
 * Step indicator rendered as a row of small pills. The active pill stretches
 * to fill the row's remaining space so progress reads at a glance.
 *
 * @example
 *   <ProgressPips currentStep={2} totalSteps={4} />
 */
export const ProgressPips: React.FC<ProgressPipsProps> = ({
  currentStep,
  totalSteps,
  className,
}) => {
  const steps = Array.from({ length: totalSteps }, (_, i) => i);

  return (
    <div
      className={[styles.root, className].filter(Boolean).join(' ')}
      role="progressbar"
      aria-valuenow={currentStep}
      aria-valuemin={1}
      aria-valuemax={totalSteps}
    >
      {steps.map((i) => {
        const isActive = i === currentStep - 1;
        return <div key={i} className={styles.pip} data-active={isActive} />;
      })}
    </div>
  );
};

export default ProgressPips;
